/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_Next_Step_GuideInputs */

const en_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens next:`)
};

const id_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang terjadi selanjutnya:`)
};

const ms_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa berlaku seterusnya:`)
};

const ca_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Què passa a continuació:`)
};

const cs_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co bude dál:`)
};

const da_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad sker der nu?`)
};

const de_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie es weitergeht:`)
};

const et_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis juhtub edasi?`)
};

const es_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué pasará ahora:`)
};

const fr_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voici ce qui se passera :`)
};

const hr_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Što sljedeće:`)
};

const it_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa succede ora:`)
};

const lv_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas notiks tālāk:`)
};

const lt_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas bus toliau:`)
};

const hu_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi történik ezután:`)
};

const nl_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat gebeurt er hierna:`)
};

const nb_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette skjer videre:`)
};

const pl_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co nastąpi:`)
};

const pt_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que esperar a seguir:`)
};

const ro_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce urmează:`)
};

const sk_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čo bude nasledovať:`)
};

const sl_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaj se bo zgodilo zdaj:`)
};

const fi_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitä tapahtuu seuraavaksi:`)
};

const sv_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad händer härnäst:`)
};

const vi_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếp theo là gì:`)
};

const tr_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi ne olacak:`)
};

const el_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Στη συνέχεια:`)
};

const bg_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какво следва:`)
};

const ru_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что произойдет дальше:`)
};

const sr_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шта се дешава даље:`)
};

const uk_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Що буде далі:`)
};

const ka_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`რა მოხდება შემდეგ:`)
};

const hi_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगे क्या होगा:`)
};

const th_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งที่จะเกิดขึ้นต่อไป:`)
};

const ko_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 단계:`)
};

const zh_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接下来会发生什么：`)
};

const zh_tw_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接下來會發生的是：`)
};

const ja_clear_next_step_guide = /** @type {(inputs: Clear_Next_Step_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル後は: `)
};

/**
* | output |
* | --- |
* | "What happens next:" |
*
* @param {Clear_Next_Step_GuideInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const clear_next_step_guide = /** @type {((inputs?: Clear_Next_Step_GuideInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Next_Step_GuideInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_clear_next_step_guide(inputs)
	if (locale === "ms") return ms_clear_next_step_guide(inputs)
	if (locale === "ca") return ca_clear_next_step_guide(inputs)
	if (locale === "cs") return cs_clear_next_step_guide(inputs)
	if (locale === "da") return da_clear_next_step_guide(inputs)
	if (locale === "de") return de_clear_next_step_guide(inputs)
	if (locale === "et") return et_clear_next_step_guide(inputs)
	if (locale === "es") return es_clear_next_step_guide(inputs)
	if (locale === "fr") return fr_clear_next_step_guide(inputs)
	if (locale === "hr") return hr_clear_next_step_guide(inputs)
	if (locale === "it") return it_clear_next_step_guide(inputs)
	if (locale === "lv") return lv_clear_next_step_guide(inputs)
	if (locale === "lt") return lt_clear_next_step_guide(inputs)
	if (locale === "hu") return hu_clear_next_step_guide(inputs)
	if (locale === "nl") return nl_clear_next_step_guide(inputs)
	if (locale === "nb") return nb_clear_next_step_guide(inputs)
	if (locale === "pl") return pl_clear_next_step_guide(inputs)
	if (locale === "pt") return pt_clear_next_step_guide(inputs)
	if (locale === "ro") return ro_clear_next_step_guide(inputs)
	if (locale === "sk") return sk_clear_next_step_guide(inputs)
	if (locale === "sl") return sl_clear_next_step_guide(inputs)
	if (locale === "fi") return fi_clear_next_step_guide(inputs)
	if (locale === "sv") return sv_clear_next_step_guide(inputs)
	if (locale === "vi") return vi_clear_next_step_guide(inputs)
	if (locale === "tr") return tr_clear_next_step_guide(inputs)
	if (locale === "el") return el_clear_next_step_guide(inputs)
	if (locale === "bg") return bg_clear_next_step_guide(inputs)
	if (locale === "ru") return ru_clear_next_step_guide(inputs)
	if (locale === "sr") return sr_clear_next_step_guide(inputs)
	if (locale === "uk") return uk_clear_next_step_guide(inputs)
	if (locale === "ka") return ka_clear_next_step_guide(inputs)
	if (locale === "hi") return hi_clear_next_step_guide(inputs)
	if (locale === "th") return th_clear_next_step_guide(inputs)
	if (locale === "ko") return ko_clear_next_step_guide(inputs)
	if (locale === "zh") return zh_clear_next_step_guide(inputs)
	if (locale === "zh-tw") return zh_tw_clear_next_step_guide(inputs)
	if (locale === "ja") return ja_clear_next_step_guide(inputs)
	return en_clear_next_step_guide(inputs)
});